import styled from 'styled-components';

interface ThProps {
  align: 'center' | 'left' | 'right';
}

interface TdProps {
  align: 'center' | 'left' | 'right';
  width?: string;
}

export const Table = styled.table`
  width: 100%;
`;

export const ColunmHead = styled.th<ThProps>`
  text-align: ThProps.align;
  padding-left: 0px;
  padding-bottom: 3px;
  border: none;
  font-size: 0.8571428571428571em;
  font-style: inherit;
  color: #6b778c;
  font-weight: 600;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif;
`;

export const Colunm = styled.td<TdProps>`
  height: 35px;
  border: 1px solid #ccc;
  padding: 0.5rem;
  text-align: TdProps.align;
  width: TdProps.width;
`;
